export default "__VITE_ASSET__a18e89ed__"